import type { HTMLProps } from 'react'

import { useEffect, useState } from 'react'

import http from '../../../lib/http'
import { CircularProgress } from '../NarusMaterial'

export function RemoteAttachment (
  { attributes, document }: {
    attributes: Pick<HTMLProps<HTMLEmbedElement>, 'style'>
    document: {
      id: string
      mime: string
      alt?: string
      title?: string
    }
  }
): JSX.Element {
  const [ fileSrc, setFileSrc ] = useState<string | null>(null)
  const [ error, setError ] = useState<string | null>(null)

  useEffect(() => {
    const fetchFile = async (): Promise<void> => {
      try {
        const response = await http.getRequest(`/attachments/${document.id}`, undefined, {
          responseType: 'blob'
        })
        const blob = new Blob([ response ], { type: document.mime })
        const objectURL = URL.createObjectURL(blob)
        setFileSrc(objectURL)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error')
      }
    }

    void fetchFile()

    return () => {
      if (fileSrc) URL.revokeObjectURL(fileSrc)
    }
  }, [])

  if (error) {
    return <p className='text-red-500'>Error: {error}</p>
  }

  if (!fileSrc) {
    return <CircularProgress />
  }

  const props = {
    title: document.title
  }

  if (document.mime.includes('pdf')) {
    return (
      <embed
        {...props}
        {...attributes}
        src={fileSrc}
      />
    )
  }

  return (
    <img
      {...props}
      {...attributes}
      src={fileSrc}
      alt={document.alt}
    />
  )
}
